import React from 'react';

const PointCloud = ({ link }) => {
  return (
    <section id="point-cloud">
      {link ? (
        <iframe src={link} title="Point Cloud" width="100%" height="500px" />
      ) : (
        <p>No point cloud selected</p>
      )}
    </section>
  );
};

export default PointCloud;
